module.exports = __webpack_public_path__ + "img/Aramex.bf4c57ec.svg";